import {
  Api,
  Ballot,
  Dns,
  Extension,
  FolderDelete,
  HistoryToggleOff,
  Inventory2,
  ListAlt,
  SwapHoriz,
} from "@mui/icons-material"
import BusinessIcon from "@mui/icons-material/Business"
import DatasetIcon from "@mui/icons-material/Dataset"
import DescriptionIcon from "@mui/icons-material/Description"
import EmailIcon from "@mui/icons-material/Email"
import EventAvailableIcon from "@mui/icons-material/EventAvailable"
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive"
import PeopleAtIcon from "@mui/icons-material/PeopleAlt"
import SmsIcon from "@mui/icons-material/Sms"
import WindowIcon from "@mui/icons-material/Window"
import {
  Box,
  CircularProgress,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material"
import Toolbar from "@mui/material/Toolbar"
import { mqtt5 } from "aws-iot-device-sdk-v2"
import { t } from "i18next"
import * as React from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../app/hooks"
import { appConfig } from "../appConfig"
import { useGetMeQuery } from "../features/me/meApi"
import {
  selectMe,
  selectMeIsReady,
  unSetTenantId,
} from "../features/me/meSlice"
import { MrtConnection } from "../iot/MrtConnection"
import MainAppbar from "./MainAppbar"
import { UnstyledLink } from "./UnstyledLink"
import { useAuthStatus } from "src/hooks/useAuthStatus"
import { InAppBannerSlot } from "src/features/inAppMessages/InAppBannerSlot"
import { InAppMessagesConsumer } from "src/features/inAppMessages/InAppMessagesConsumer"
import { InAppMessagesTopic } from "shared/inAppMessagesData"

type SaMenuItem = {
  labelKey: string
  icon?: JSX.Element
  url: string
  divider?: boolean
  disabled?: boolean
  visible: boolean
}

export const SaMenuItems = [
  {
    labelKey: "organizations",
    icon: <BusinessIcon />,
    url: "/sa/tenants",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "users",
    icon: <PeopleAtIcon />,
    url: "/sa/users",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "administrators",
    icon: <PeopleAtIcon />,
    url: "/sa/administrators",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "orgMembers",
    icon: <PeopleAtIcon />,
    url: "/sa/org-members",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "lockers",
    icon: <WindowIcon />,
    url: "/sa/lockers",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "smsExpeditors",
    icon: <SmsIcon />,
    url: "/sa/sms-expeditors",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "emailExpeditors",
    icon: <EmailIcon />,
    url: "/sa/email-expeditors",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "reservations",
    icon: <EventAvailableIcon />,
    url: `/sa/reservations`,
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "reservationAudit",
    icon: <HistoryToggleOff />,
    url: `/sa/reservation-audit?searchParams=%7B"type"%3A"byEvent"%2C"event"%3A"pickup"%7D`,
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "meventLog",
    icon: <ListAlt />,
    url: "/sa/event-log",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "adminLogs",
    icon: <Ballot />,
    url: "/sa/admin-logs",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "seedTrackers",
    icon: <DatasetIcon />,
    url: "/sa/seed-trackers",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "sstApi",
    icon: <Dns />,
    url: "/sa/sst",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "sstv2Api",
    icon: <Api />,
    url: "/sa/sstv2",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "sstv2Migration",
    icon: <SwapHoriz />,
    url: "/sa/sstv2-migration",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "reservationSyncs",
    icon: <SwapHoriz />,
    url: "/sa/reservation-syncs",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "monthlyReports",
    icon: <DescriptionIcon />,
    url: "/sa/monthly-reports",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "sl1Import",
    icon: <Inventory2 />,
    url: "/sa/sl1-import",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "somum",
    icon: <SmsIcon />,
    url: "/sa/somum",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "notifDeliveries",
    icon: <NotificationsActiveIcon />,
    url: "/sa/notif-deliveries?tab=0",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "features",
    icon: <Extension />,
    url: "/sa/features",
    divider: false,
    disabled: false,
    visible: true,
  },
  {
    labelKey: "deletedThings",
    icon: <FolderDelete />,
    url: "/sa/deleted-things",
    divider: false,
    disabled: false,
    visible: true,
  },
] as SaMenuItem[]

export type SaMenuGroup = { titleKey: string; labelKeys: string[] }

export const SaMenuGroups: SaMenuGroup[] = [
  {
    titleKey: "adminGroupAccounts",
    labelKeys: ["organizations", "users", "administrators", "orgMembers"],
  },
  {
    titleKey: "adminGroupLockersReservations",
    labelKeys: ["lockers", "reservations", "reservationAudit"],
  },
  {
    titleKey: "adminGroupMessaging",
    labelKeys: ["smsExpeditors", "emailExpeditors", "notifDeliveries", "somum"],
  },
  {
    titleKey: "adminGroupAuditLogs",
    labelKeys: ["meventLog", "adminLogs", "seedTrackers"],
  },
  {
    titleKey: "adminGroupIntegrations",
    labelKeys: [
      "sstApi",
      "sstv2Api",
      "sstv2Migration",
      "reservationSyncs",
      "sl1Import",
    ],
  },
  {
    titleKey: "adminGroupReports",
    labelKeys: ["monthlyReports"],
  },
  {
    titleKey: "adminGroupSystem",
    labelKeys: ["features", "deletedThings"],
  },
]

const SaMenu: React.FC<{ selectedMenuItemLabelKey?: string }> = ({
  selectedMenuItemLabelKey,
}) => {
  const { t } = useTranslation()

  const visibleItems = SaMenuItems.filter((i) => i.visible)
  const itemByKey = new Map(visibleItems.map((i) => [i.labelKey, i]))
  const groupedKeys = new Set(SaMenuGroups.flatMap((g) => g.labelKeys))
  const ungrouped = visibleItems.filter((i) => !groupedKeys.has(i.labelKey))

  const renderItem = (item: SaMenuItem) => {
    const isSelected = selectedMenuItemLabelKey === item.labelKey
    return (
      <UnstyledLink
        to={item.url}
        key={item.labelKey}
        disabled={item.disabled}
      >
        <ListItemButton
          divider={item.divider}
          disabled={item.disabled}
          selected={isSelected}
          disableRipple
          sx={{
            position: "relative",
            borderRadius: 1.25,
            mb: 0.25,
            py: 0.75,
            px: 1.25,
            transition: "background-color 140ms ease",
            "&:hover": {
              bgcolor: "rgba(35, 66, 133, 0.04)",
            },
            "&.Mui-selected": {
              bgcolor: "rgba(35, 66, 133, 0.08)",
              "&:hover": { bgcolor: "rgba(35, 66, 133, 0.12)" },
              "&::before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: 8,
                bottom: 8,
                width: 3,
                borderRadius: 2,
                bgcolor: "primary.main",
              },
              "& .MuiListItemIcon-root": { color: "primary.main" },
              "& .MuiListItemText-primary": {
                color: "primary.main",
                fontWeight: 600,
              },
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 36,
              color: "rgba(0, 0, 0, 0.6)",
              "& svg": { fontSize: "1.2rem" },
            }}
          >
            {item.icon}
          </ListItemIcon>
          <ListItemText
            primary={t(item.labelKey)}
            primaryTypographyProps={{
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "text.primary",
              letterSpacing: "-0.005em",
            }}
          />
        </ListItemButton>
      </UnstyledLink>
    )
  }

  const groupHeadingSx = {
    fontSize: "0.66rem",
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase" as const,
    color: "text.secondary",
    px: 1.75,
    mb: 0.5,
  }

  return (
    <Box sx={{ px: 1, pt: 1.25, pb: 2 }}>
      {SaMenuGroups.map((group, gi) => {
        const items = group.labelKeys
          .map((k) => itemByKey.get(k))
          .filter((x): x is SaMenuItem => Boolean(x))
        if (items.length === 0) return null
        return (
          <Box key={group.titleKey} sx={{ mt: gi === 0 ? 0.5 : 2 }}>
            <Typography sx={groupHeadingSx}>{t(group.titleKey)}</Typography>
            <List disablePadding>{items.map(renderItem)}</List>
          </Box>
        )
      })}
      {ungrouped.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <List disablePadding>{ungrouped.map(renderItem)}</List>
        </Box>
      )}
    </Box>
  )
}

interface SaLayoutProps {
  children: React.ReactNode
  selectedMenuItemLabelKey?: string
}

const SaLayout: React.FC<SaLayoutProps> = ({
  children,
  selectedMenuItemLabelKey,
}) => {
  const { isSignedIn, isLoaded } = useAuthStatus()

  const dispatch = useAppDispatch()

  const isReady = useAppSelector(selectMeIsReady)

  useGetMeQuery("noId", {
    skip: !isLoaded || !isSignedIn,
  })
  const { user } = useAppSelector(selectMe)

  React.useEffect(() => {
    dispatch(unSetTenantId())
  }, [dispatch])

  const selectedItem = SaMenuItems.filter(
    (item) => item.labelKey === selectedMenuItemLabelKey,
  )[0]
  return (
    <Stack data-ui="UI-SL2W-004"
      direction="column"
      sx={{
        display: "flex",
        height: "100vh",
        width: "100vw",
      }}
    >
      <MainAppbar isSuperAdminToolbar={true} />
      <Toolbar />
      <InAppBannerSlot slot="top" />

      {!(isLoaded || !isReady) && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Stack direction="row">
        <Box data-ui="UI-SL2W-005"
          sx={{
            width: appConfig.mainMenuWidth,
            flexShrink: 0,
            height: `calc(100vh - ${appConfig.mainAppBarHeight}px)`,
            bgcolor: "#fff",
            borderRight: "1px solid",
            borderColor: "rgba(0, 0, 0, 0.08)",
            overflowY: "auto",
            "&::-webkit-scrollbar": { width: 6 },
            "&::-webkit-scrollbar-thumb": {
              bgcolor: "rgba(0,0,0,0.15)",
              borderRadius: 3,
            },
            "&::-webkit-scrollbar-track": { bgcolor: "transparent" },
          }}
        >
          <Box sx={{ px: 2, pt: 2.5, pb: 1.5 }}>
            {selectedItem?.labelKey ? (
              <Stack direction="row" spacing={1.25} alignItems="center">
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 1.25,
                    backgroundImage:
                      "linear-gradient(135deg, rgba(35, 66, 133, 0.14), rgba(148, 210, 194, 0.16))",
                    color: "primary.main",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    "& svg": { fontSize: "1.05rem" },
                  }}
                >
                  {selectedItem.icon}
                </Box>
                <Typography
                  noWrap
                  sx={{
                    fontSize: "0.9rem",
                    fontWeight: 600,
                    letterSpacing: "-0.01em",
                    color: "text.primary",
                  }}
                >
                  {t(selectedItem.labelKey)}
                </Typography>
              </Stack>
            ) : (
              <Typography
                noWrap
                sx={{
                  fontSize: "0.7rem",
                  fontWeight: 600,
                  letterSpacing: "0.14em",
                  textTransform: "uppercase",
                  color: "text.secondary",
                  pl: 0.5,
                }}
              >
                {t("adminApp")}
              </Typography>
            )}
          </Box>
          <Divider sx={{ borderColor: "rgba(0, 0, 0, 0.06)" }} />
          <SaMenu selectedMenuItemLabelKey={selectedMenuItemLabelKey} />
        </Box>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            maxHeight: `calc(100vh - ${appConfig.mainAppBarHeight}px)`,
            overflow: "auto",
            bgcolor: "#fafbfe",
            backgroundImage: `
              radial-gradient(1150px 580px at 0% -9%, rgba(35, 66, 133, 0.08), transparent 62%),
              radial-gradient(950px 520px at 100% -5%, rgba(148, 210, 194, 0.11), transparent 58%),
              radial-gradient(780px 450px at 50% 108%, rgba(35, 66, 133, 0.05), transparent 65%)
            `,
            backgroundAttachment: "local",
            backgroundRepeat: "no-repeat",
          }}
        >
          <InAppBannerSlot slot="below-header" />
          {children}
        </Box>
      </Stack>
      <InAppMessagesConsumer />
      {isReady && user?.id && (
        <MrtConnection
          tenantId={"noId"}
          subscribePacket={{
            subscriptions: [
              {
                topicFilter: `mrt/us/${user?.id}/#`,
                qos: mqtt5.QoS.AtLeastOnce,
              },
              {
                topicFilter: `mrt/dsync-platform/#`,
                qos: mqtt5.QoS.AtLeastOnce,
              },
              {
                topicFilter: InAppMessagesTopic,
                qos: mqtt5.QoS.AtLeastOnce,
              },
            ],
          }}
        />
      )}
    </Stack>
  )
}

export default SaLayout
